/* eslint-disable complexity */
import React from "react";

import { useCountriesOrRegionsList } from "../../../../helpers/countriesOrRegionsList";
import { DropdownOption } from "../../../../helpers/optionSets";
import { CommonIntroContactDataType } from "../../../../models/forms";
import { ReadOnlyFormItem } from "../appInfoModelsAndHelpers";
import { ReadOnlyForm } from "../ReadOnlyForm";

type ReadOnlyContactProps = {
  dataInForm: CommonIntroContactDataType;
};

const ContactConfig: Map<string, ReadOnlyFormItem> = new Map([
  ["firstName", {}],
  ["lastName", {}],
  ["businessTitle", {}],
  ["email", {}],
  [
    "countryOrRegion",
    {
      mapper: (
        data: CommonIntroContactDataType,
        _localizedStrings: Map<string, string>,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        additionalData?: Map<string, any>
      ) => {
        if (!additionalData) {
          return null;
        }
        const countriesOrRegionsList = additionalData.get(
          "countriesOrRegionsList"
        ) as Array<DropdownOption>;
        const selectedCountryCode = data.countryOrRegion;
        for (const country of countriesOrRegionsList) {
          if (country.value === selectedCountryCode) {
            return country.label;
          }
        }
        return "";
      },
    },
  ],
  [
    "address",
    {
      mapper: (data: CommonIntroContactDataType) => {
        if (!data.addressLine1 && !data.addressLine2) {
          return "";
        }
        if (!data.addressLine2) {
          return data.addressLine1;
        }
        return `${data.addressLine1} </br> ${data.addressLine2}`;
      },
      isAnswerWithHtmlContent: true,
    },
  ],
  ["city", {}],
  ["stateRegion", {}],
  ["postalCode", {}],
  ["phone", {}],
]);

export const ReadOnlyContact = ({ dataInForm }: ReadOnlyContactProps) => {
  const countriesOrRegionsList = useCountriesOrRegionsList();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const additionalData = new Map<string, any>([["countriesOrRegionsList", countriesOrRegionsList]]);

  return (
    <ReadOnlyForm
      formConfig={ContactConfig}
      formData={dataInForm}
      additionalData={additionalData}
    />
  );
};
